<script setup>
import { watch } from 'vue'
import { useMainStore } from '../stores/main-store'

const mainStore = useMainStore()

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

watch(
  () => mainStore.filterQuery,
  () => {
    // mainStore.removeFilters()
  }
)
</script>

<template>
  <div class="search-input">
    <input
      v-model="mainStore.filterQuery"
      type="text"
      :placeholder="__('Search for a work', 'lavnosrad')"
    />
    <i class="vn-icons-search"></i>
  </div>
</template>
